module.exports = __webpack_public_path__ + "static/img/product_4.b518ebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_4.jpg
// module id = 5hQ+
// module chunks = 1